// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"WX-z","subtitle":"XX-z","wrapper":"YX-z","leftArrow":"ZX-z","rightArrow":"_X-z"};